import styled from 'styled-components';

interface ButtonProps {
  disabled?: boolean;
  invertedColor?: boolean;
  $noBorder?: boolean;
  customColor?: string;
}

interface ButtonLabelProps {
  $loading?: boolean;
}

export const StyledButton = styled.button<ButtonProps>`
  position: relative;
  width: 100%;
  height: 50px;
  font-weight: 600;
  border-radius: 12px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  line-height: 40px;
  font-size: 16px;
  transition: 0.3s;
  text-align: center;
  border: ${({ $noBorder, invertedColor }) => (!invertedColor || $noBorder ? 'none' : '2px solid')};
  padding: 0 16px;

  border-color: ${({ theme, invertedColor, disabled }) => {
    if (invertedColor) {
      return disabled ? theme.button.disabled : theme.button.invertedColor;
    }
    return theme.button.background;
  }};

  color: ${({ theme, invertedColor, disabled }) => {
    if (invertedColor) {
      return disabled ? theme.button.disabled : theme.button.invertedColor;
    }
    return theme.button.color;
  }};

  background: ${({ theme, disabled, invertedColor, customColor }) => {
    if (customColor) {
      return customColor;
    }
    if (invertedColor) {
      return theme.button.invertedBackground;
    }
    return disabled ? theme.button.disabled : theme.button.background;
  }};
`;

export const ButtonLabel = styled.span<ButtonLabelProps>`
  visibility: ${({ $loading }) => ($loading ? 'hidden' : 'visible')};
  color: inherit;
  font-size: inherit;
`;

export const Box = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  size: 10px;
`;
